import { useEffect, useRef } from 'react';
import { setAfterSubmitAction, previousStep } from '#action/shipment/form';

// Lets the wizard submit the step that is currently mounted
export const useStepSubmit = (registerStepSubmit, methods, onFormSubmit) => {
  const submitRef = useRef(null);
  submitRef.current = methods.handleSubmit(onFormSubmit);

  useEffect(() => {
    if (typeof registerStepSubmit !== 'function') {
      return undefined;
    }
    registerStepSubmit(() => submitRef.current());
    return () => registerStepSubmit(null);
  }, [registerStepSubmit]);
};

// Back runs the step's own submit so its values reach shipmentForm; create mode skips validation
export const submitAndGoBack = (dispatch, methods, onFormSubmit, { validate = true } = {}) => {
  dispatch(setAfterSubmitAction(() => dispatch(previousStep())));
  if (validate) {
    methods.handleSubmit(onFormSubmit)();
  } else {
    onFormSubmit(methods.getValues());
  }
};
